import { render, staticRenderFns } from "./TipoHistoricoForm.vue?vue&type=template&id=6779fbdd&scoped=true"
import script from "./TipoHistoricoForm.vue?vue&type=script&lang=js"
export * from "./TipoHistoricoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6779fbdd",
  null
  
)

export default component.exports